class SafeLoadScripts extends HTMLElement {
  constructor() {
    super();
  }


  connectedCallback() {
    const scripts = this.querySelectorAll('safe-load-scripts > script');

    scripts.forEach((script) => {
      const key = script.dataset.flowLoadKey;

      const scriptLoaded = window.wetheme.webcomponentRegistry.checkScriptLoaded(key);
      if(!scriptLoaded) {
        const postLoadedScript = document.createElement('script');
        const {src, defer, async, type} = script;
        postLoadedScript.src = src;
        postLoadedScript.defer = defer;
        postLoadedScript.async = async;
        postLoadedScript.type = type;


        this.parentElement.appendChild(postLoadedScript);

      }
    })

  }
}
  
customElements.define('safe-load-scripts', SafeLoadScripts);


document.addEventListener('DOMContentLoaded', function() {
    // Selecciona todos los contenedores
    const gridViewItems = document.querySelectorAll('.grid-view-item');

    // Asegura que los elementos existen
    if (gridViewItems.length) {
        gridViewItems.forEach(function(item) {
            // Cuando el mouse entra en el contenedor
            item.addEventListener('mouseenter', function() {
                // Muestra los botones
                const buttons = item.querySelectorAll('.quick-add-wrapper.agregar_a_carrito');
                buttons.forEach(function(button) {
                    button.style.display = 'block';
                });
            });

            // Cuando el mouse sale del contenedor
            item.addEventListener('mouseleave', function() {
                // Oculta los botones
                const buttons = item.querySelectorAll('.quick-add-wrapper.agregar_a_carrito');
                buttons.forEach(function(button) {
                    button.style.display = 'none';
                });
            });
        });
    }
});


// Espera a que se cargue el DOM
document.addEventListener("DOMContentLoaded", function() {
    // Selecciona todos los elementos <a> con el atributo title
    var elementosAConTitle = document.querySelectorAll('a[title]');
    
    // Itera sobre los elementos y elimina el atributo title
    elementosAConTitle.forEach(function(elemento) {
        elemento.removeAttribute('title');
    });
});


